import React from 'react';
import { useContext } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { ManagedByReitType } from '../../utils/EstateDataType';
import { AppContext } from '../../context/AppContext';
import { SubmitSearchButtonId } from '../../utils/SearchPanelConst';
import './ManagedReit.css';

type Props = {

};

const ManagedReit: React.VFC<Props> = () => {
  const [ t ] = useTranslation();
  const { register } = useFormContext();
  const { myLang, searchCond } = useContext(AppContext);

  const handleChange = () => {
    // 変更時に再検索させる。
    const submit_search_button = document.getElementById(SubmitSearchButtonId);
    if (!submit_search_button) return;
    submit_search_button.click();
  }

  const is_selected = (value: string) => {
    if (searchCond['managed_reit_type'] === value) {
      return true;
    } else {
      return false;
    }
  }

  return (
    <div id="ManagedReit">
      <div className="searchgroup">
        <span className="searchfieldlabel">{t('REIT保有/非保有')}</span>
        <select id="ManagedReitType" className={myLang} {...register('managed_reit_type', { onChange: handleChange })}>
          <option value="0" selected={!('managed_reit_type' in searchCond)} disabled></option>
          <option value="0">{t('指定なし')}</option>
          <option value={ManagedByReitType.Managed} selected={is_selected(ManagedByReitType.Managed)}>{t('REIT保有')}</option>
          <option value={ManagedByReitType.NotManaged} selected={is_selected(ManagedByReitType.NotManaged)}>{t('REIT非保有')}</option>
        </select> 
      </div>
    </div>
  );
}

export default ManagedReit;
